import { render } from "./CameraStatistics.vue?vue&type=template&id=40aeb37a&ts=true"
import script from "./CameraStatistics.vue?vue&type=script&lang=ts"
export * from "./CameraStatistics.vue?vue&type=script&lang=ts"

import "./CameraStatistics.vue?vue&type=style&index=0&id=40aeb37a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__